import { useState, useEffect } from "react";

//
//component
//redux
//selector
//actions
export const TriggerInit = ({ text, setContent }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (text) {
      setContent(text);
    }
  }, []);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
